export default [
  {
    path: '/usuarios',
    name: 'usuarios',
    component: () => import(/* webpackChunkName: "usuarios" */ '../../views/usuarios/Usuarios')
  },
  {
    path: '/usuarios/cadastro',
    name: 'cadastro-usuarios',
    component: () => import(/* webpackChunkName: "cadastro-usuarios" */ '../../views/usuarios/Cadastro')
  },
  {
    path: '/usuarios/:id',
    name: 'edicao-usuario-administracao',
    component: () => import(/* webpackChunkName: "edicao-usuario-administracao" */ '../../views/usuarios/EdicaoUsuarioAdministracao')
  }
]
